module.exports = __webpack_public_path__ + "static/media/achtergrond.575cfa2f.jpg";